module.exports = __webpack_public_path__ + "img/home_know_more_img_01.bc5e0f25.png";